<template>
    <svg :width="width" :height="height" viewBox="0 0 27 27" fill="none">
        <path
            d="M16.9475 11.8695C17.8824 11.8695 18.6402 11.1116 18.6402 10.1768C18.6402 9.24196 17.8824 8.48413 16.9475 8.48413C16.0127 8.48413 15.2549 9.24196 15.2549 10.1768C15.2549 11.1116 16.0127 11.8695 16.9475 11.8695Z"
            :fill="color"
            class="icon"
        />
        <path
            d="M9.04862 11.8695C9.98346 11.8695 10.7413 11.1116 10.7413 10.1768C10.7413 9.24196 9.98346 8.48413 9.04862 8.48413C8.11379 8.48413 7.35596 9.24196 7.35596 10.1768C7.35596 11.1116 8.11379 11.8695 9.04862 11.8695Z"
            :fill="color"
            class="icon"
        />
        <path
            d="M12.987 1.71359C6.75801 1.71359 1.71387 6.76902 1.71387 12.998C1.71387 19.227 6.75801 24.2825 12.987 24.2825C19.2273 24.2825 24.2827 19.227 24.2827 12.998C24.2827 6.76902 19.2273 1.71359 12.987 1.71359ZM12.9983 22.0256C8.01058 22.0256 3.97075 17.9857 3.97075 12.998C3.97075 8.01031 8.01058 3.97048 12.9983 3.97048C17.986 3.97048 22.0259 8.01031 22.0259 12.998C22.0259 17.9857 17.986 22.0256 12.9983 22.0256ZM7.35608 15.2549C8.23627 17.8955 10.4255 19.7687 12.9983 19.7687C15.5712 19.7687 17.7603 17.8955 18.6405 15.2549H7.35608Z"
            :fill="color"
            class="icon"
        />
    </svg>
</template>

<script>
export default {
    name: 'Positive',
    props: {
        color: {
            type: String,
            default: '#6E6E6E',
        },
        width: {
            type: Number,
            default: 32,
        },
        height: {
            type: Number,
            default: 32,
        },
    },
}
</script>

<style lang="sass" scoped>
.icon
    transition: 0.5s ease all
</style>
